// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m78j","name":"styles_name__1K20W","phone":"styles_phone__2FrPH"};